import { Link } from "react-router-dom";


const TabLink = ({ to, active, children, style }) => (
    <Link
      to={to}
      // style={{
      //   padding: "4px 8px",
      //   textDecoration: "none",
      //   color: active ? "blue" : "black",
      //   border: '1px solid #ccc',
      //   // borderBottom: active ? "2px solid blue" : "none",
      //   borderBottom: active ? "none" : "1px solid #ccc",
      // }}
      style={style}
    >
      {children}
    </Link>
  );

  export default TabLink;